// Generated from @cascade/api-contracts. Do not edit.
// Run: pnpm --filter @cascade/api-client build

import type {
  TApiRequestOptions,
  TApiTransport,
} from '#request/request.types.ts';
import type {
  TBuilderCreateExperienceRequestPayload,
  TBuilderCreateExperienceResponsePayload,
  TBuilderDeleteExperienceDocumentRequestPayload,
  TBuilderDeleteExperienceDocumentResponsePayload,
  TBuilderDeleteExperienceRequestPayload,
  TBuilderDeleteExperienceResponsePayload,
  TBuilderGetExperienceRequestPayload,
  TBuilderGetExperienceResponsePayload,
  TBuilderListExperienceDocumentsRequestPayload,
  TBuilderListExperienceDocumentsResponsePayload,
  TBuilderListExperiencesRequestPayload,
  TBuilderListExperiencesResponsePayload,
  TBuilderUpdateExperienceRequestPayload,
  TBuilderUpdateExperienceResponsePayload,
  TBuilderUploadExperienceDocumentRequest,
  TBuilderUploadExperienceDocumentResponsePayload,
} from './ge-builder.types.ts';

export const createGeBuilderApi = (transport: TApiTransport) => ({
  /** Creates a guided experience */
  builderCreateExperience: (
    payload: TBuilderCreateExperienceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderCreateExperienceRequestPayload,
      TBuilderCreateExperienceResponsePayload
    >('/builder_create_experience', payload, options),

  /** Deletes a guided experience */
  builderDeleteExperience: (
    payload: TBuilderDeleteExperienceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderDeleteExperienceRequestPayload,
      TBuilderDeleteExperienceResponsePayload
    >('/builder_delete_experience', payload, options),

  /** Deletes a guided-experience document */
  builderDeleteExperienceDocument: (
    payload: TBuilderDeleteExperienceDocumentRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderDeleteExperienceDocumentRequestPayload,
      TBuilderDeleteExperienceDocumentResponsePayload
    >('/builder_delete_experience_document', payload, options),

  /** Returns a guided experience */
  builderGetExperience: (
    payload: TBuilderGetExperienceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderGetExperienceRequestPayload,
      TBuilderGetExperienceResponsePayload
    >('/builder_get_experience', payload, options),

  /** Lists a guided experience's documents */
  builderListExperienceDocuments: (
    payload: TBuilderListExperienceDocumentsRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderListExperienceDocumentsRequestPayload,
      TBuilderListExperienceDocumentsResponsePayload
    >('/builder_list_experience_documents', payload, options),

  /** Lists the project's guided experiences */
  builderListExperiences: (
    payload: TBuilderListExperiencesRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderListExperiencesRequestPayload,
      TBuilderListExperiencesResponsePayload
    >('/builder_list_experiences', payload, options),

  /** Updates a guided experience */
  builderUpdateExperience: (
    payload: TBuilderUpdateExperienceRequestPayload,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderUpdateExperienceRequestPayload,
      TBuilderUpdateExperienceResponsePayload
    >('/builder_update_experience', payload, options),

  /** Uploads a document to a guided experience */
  builderUploadExperienceDocument: (
    payload: TBuilderUploadExperienceDocumentRequest,
    options?: TApiRequestOptions,
  ) =>
    transport.post<
      TBuilderUploadExperienceDocumentRequest,
      TBuilderUploadExperienceDocumentResponsePayload
    >('/builder_upload_experience_document', payload, {
      ...options,
      contentType: 'multipart/form-data',
    }),
});
